import { POST_LANGUAGE, GET_LANGUAGE } from 'helpers/basicRequest';
const language_helper = {
  empty(mixedVar) {
    //  discuss at: https://locutus.io/php/empty/
    // original by: Philippe Baumann
    //    input by: Onno Marsman (https://twitter.com/onnomarsman)
    //    input by: LH
    //    input by: Stoyan Kyosev (https://www.svest.org/)
    // bugfixed by: Kevin van Zonneveld (https://kvz.io)
    // improved by: Onno Marsman (https://twitter.com/onnomarsman)
    // improved by: Francesco
    // improved by: Marc Jansen
    // improved by: Rafał Kukawski (https://blog.kukawski.pl)
    //   example 1: empty(null)
    //   returns 1: true
    //   example 2: empty(undefined)
    //   returns 2: true
    //   example 3: empty([])
    //   returns 3: true
    //   example 4: empty({})
    //   returns 4: true
    //   example 5: empty({'aFunc' : function () { alert('humpty'); } })
    //   returns 5: false
    let undef
    let key
    let i
    let len
    const emptyValues = [undef, null, false, 0, '', '0']
    for (i = 0, len = emptyValues.length; i < len; i++) {
      if (mixedVar === emptyValues[i]) {
        return true
      }
    }
    if (typeof mixedVar === 'object') {
      for (key in mixedVar) {
        if (mixedVar.hasOwnProperty(key)) {
          return false
        }
      }
      return true
    }
    return false
  },
  getLanguageString: function (key) {
    let languageKeys = sessionStorage.getItem('languageKeys');
    if (this.empty(languageKeys)) {
      sessionStorage.removeItem('languageKeys');
      return '' 
    } else {
      languageKeys = JSON.parse(sessionStorage.getItem('languageKeys'))
      return languageKeys[key]
    }


  },
  getLanguageFile(){
    
    
      document.body.classList.add('is-hidden')
      const fetcher = async () => {
        //const list=await POST_LANGUAGE('indicators/getLanguageStrings');
        const list=await GET_LANGUAGE('indicators/languages');
   
          sessionStorage.setItem('languageKeys', JSON.stringify(list.data.info.content))
         
        //

        
      };
      fetcher();
      document.body.classList.remove('is-hidden')

    
  }
}

export default language_helper;